import { render, staticRenderFns } from "./MinimumOrderQuantity.vue?vue&type=template&id=001c40e1&scoped=true"
import script from "./MinimumOrderQuantity.vue?vue&type=script&lang=js"
export * from "./MinimumOrderQuantity.vue?vue&type=script&lang=js"
import style0 from "./MinimumOrderQuantity.vue?vue&type=style&index=0&id=001c40e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001c40e1",
  null
  
)

export default component.exports